export const en = {
    'leningrad-region': 'Saint-Petersburg and Leningrad Region',
    'moscow-region': 'Moscow and Moscow Region',
    'russia-cis-georgia': 'Russia, CIS and Georgia ',
    ukraine: 'Ukraine'
};
